import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import styled, { css } from 'styled-components';
import { StyledErrorMessageBlock } from '../../base/forms/formik';

const StyledFileField = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1rem;
	border: 2px dashed ${({ theme }) => theme.colors.borderColor};
	cursor: pointer;
	font-size: 1.6rem;
	font-weight: 600;
	overflow: hidden;
	transition: border-color 200ms ease, color 200ms ease;

	&:hover {
		border-color: ${({ theme }) => theme.colors.borderDark};
	}

	${({ dragActive }) => dragActive && css`
		border-color: ${({ theme }) => theme.colors.borderDark};
	`}

	${({ fileSelected }) => fileSelected && css`
		border-color: ${({ theme }) => theme.colors.success};
		color: ${({ theme }) => theme.colors.success};

		&:hover {
			border-color: ${({ theme }) => theme.colors.success};
		}
	`}
`;

const StyledFileFieldText = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	min-height: 6rem;
`;

const SelectedFileContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

const SelectedFileName = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.colors.grayLighter};
	line-height: 1;
	padding-bottom: 1rem;
`;

const FormFileField = ({
	field,
	onFiles,
	invalidFiles,
	required
}) => {
	const [files, setFiles] = useState([]);
	const fileSelected = files.length > 0;
	const invalidFile = [];
	for(let i = 0; i < files.length; i++) {
		invalidFiles.filter(x => x.FileName === files[i].name);
	}
	const currentFileIsInvalid = invalidFile.length > 0;
	let invalidFileText = '';

	if(currentFileIsInvalid) {
		if(invalidFile[0].ExcessiveFileSize) invalidFileText = ', skráin er of stór';
		if(invalidFile[0].InvalidExtension) invalidFileText = ', þessi skráargerð er ekki leyfileg';
	}

	const onDrop = (accepted) => {
		const allFiles = { files: accepted, name: field.fileNameBase  }
		setFiles(accepted)
		onFiles(allFiles, field.fieldName);
	};

	return (
		<>
			<Dropzone onDrop={onDrop} multiple>
				{({ getRootProps, getInputProps, isDragActive }) => (
					<StyledFileField {...getRootProps()} dragActive={isDragActive} fileSelected={fileSelected}>
						<input {...getInputProps()} />
						<StyledFileFieldText>
							{
								fileSelected
								? (
										<SelectedFileContainer>
											<div>{field.labelName}</div>
											{files.map(file => (
												<SelectedFileName key={file.name}>
													{file.name}
												</SelectedFileName>
											))}
										</SelectedFileContainer>
								)
								: (
									<div>
										<span>{field.labelName}</span>
										{required && <span>*</span>}
									</div>
								)
							}
						</StyledFileFieldText>
					</StyledFileField>
				)}
			</Dropzone>
			{
				currentFileIsInvalid && (
					<StyledErrorMessageBlock>
						<span>Ekki tókst að hlaða upp þessari skrá</span>
						<span>{invalidFileText}</span>
					</StyledErrorMessageBlock>
				)
			}
		</>
	);
};

FormFileField.propTypes = {
	field: PropTypes.object.isRequired,
	onFiles: PropTypes.func.isRequired,
	invalidFiles: PropTypes.array.isRequired,
	required: PropTypes.bool
};

FormFileField.defaultProps = {
	required: false
};

export default FormFileField;
